// JsFromRoutes CacheKey 2923f5a62f6cc95543b9f39ff4eeaabf
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  updateEntitlement: /* #__PURE__ */ definePathHelper('patch', '/god-mode/accounts/:id/update_entitlement'),
  resetEntitlement: /* #__PURE__ */ definePathHelper('delete', '/god-mode/accounts/:id/reset_entitlement'),
  index: /* #__PURE__ */ definePathHelper('get', '/god-mode/accounts'),
  show: /* #__PURE__ */ definePathHelper('get', '/god-mode/accounts/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/god-mode/accounts/:id'),
}
